import { Box, Grid2, Typography } from '@mui/material'
import { useEffect } from 'react'
import QRCode from 'react-qr-code'
import { useNavigate } from 'react-router-dom'

import { useAuth } from 'components/AuthProvider'
import Button from 'components/Button'
import LoadingWrapper from 'components/layout/LoadingWrapper'
import { useMutateAssociateSoftwareToken } from 'hooks/useTwoFa'

export default function TwoStepScan(): JSX.Element {
  const { user, setToast } = useAuth()
  const navigate = useNavigate()

  const associateMutation = useMutateAssociateSoftwareToken()

  useEffect(() => {
    if (!user?.authenticatorAppEnabled) {
      associateMutation.mutate(undefined, {
        onError: (error: unknown) =>
          setToast({
            open: true,
            message:
              error instanceof Error ? error.message : 'Failed to load QR code',
            type: 'error',
            duration: 3000
          })
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  function handleClick() {
    navigate('/account/more/two_step_authentication/code')
  }

  const qrCodeUri = associateMutation.data?.qrCodeUri

  return (
    <Grid2 container>
      <Grid2 size={{ xs: 12 }}>
        <Typography
          align='left'
          variant='h2'
          fontSize='48px'
          textTransform='uppercase'
        >
          Scan this QR code
        </Typography>
      </Grid2>
      <Grid2 mb={4} size={{ xs: 12 }}>
        <Typography align='left' fontSize='medium'>
          With your authenticator app, scan this QR code
        </Typography>
      </Grid2>
      <Grid2 container sx={{ marginTop: 6, marginBottom: 6 }} size={{ xs: 12 }}>
        <Box
          sx={{
            width: '256px',
            height: '256px',
            position: 'relative'
          }}
        >
          <LoadingWrapper loading={!qrCodeUri} size={160}>
            {qrCodeUri ? <QRCode id='qrCode' value={qrCodeUri} /> : null}
          </LoadingWrapper>
        </Box>
      </Grid2>
      <Grid2 sx={{ mt: 4, textAlign: 'center' }} size={{ xs: 12 }}>
        <Button color='primary' fullWidth onClick={handleClick}>
          Next
        </Button>
      </Grid2>
    </Grid2>
  )
}
